// extracted by mini-css-extract-plugin
module.exports = {"label":"FormHeader_label__KO_3H"};